import { FormGroup, ValidationErrors } from "@angular/forms";
import * as moment from "moment";

export class ModelHelpers {

    public static copyFromForm(formValues: any, destObject: any) {
      
        Object.keys(destObject).forEach(key => {
            console.log(key)
            if (formValues[key] !== undefined) {
                destObject[key] = formValues[key];
            }
        });

    }

    public static dateUtcFormat(dateString: string) {
        if (dateString === '' || dateString === null) {
            return null;
        }

        const formats = ['YYYY-MM-DDTHH:mm:ss', 'DD/MM/YYYY', 'DD-MM-YYYY', 'YYYY-MM-DD', 'DDMMYYYY']
        const date = moment.utc(dateString, formats).parseZone();
        console.log(date)
        return date.isValid() ? date : null;
    }

    public static getFormValidationErrors(formGroup: FormGroup, customFieldNamesError: any) {
        console.log(formGroup.controls)

        const invalidFields = {}; // Guardamos los campos que no son válidos

        Object.keys(formGroup.controls).forEach(key => {
            const controlErrors: ValidationErrors = formGroup.get(key).errors;
            if (controlErrors != null) {
                invalidFields[customFieldNamesError[key] || key] = controlErrors;
            }
        });

        let errorMessage = 'Por favor, complete todos los campos requeridos:\n';
        for (const fieldName in invalidFields) {
            if (invalidFields.hasOwnProperty(fieldName)) {
                errorMessage += `${fieldName},\n`;
            }
        }
        errorMessage = errorMessage.replace(/,\n$/, '.');
        return errorMessage;
    }
}